<template>
  <article class="transaction-chart card">
    <ApexChart class="transaction-chart__chart" width="100%" height="260" type="area" :options="options" :series="series" />
  </article>
</template>

<script>
  import ApexChart from 'vue-apexcharts';
  import { format, createChartArray } from '@/helpers';
  import { mapState, mapGetters, mapMutations } from 'vuex';
  import ChartHeader from '@/components/Transaction/Chart/Header';

  export default {
    components: {
      ApexChart,
      ChartHeader,
    },

    data: () => ({
      positive: [[0, 0]],
      negative: [[0, 0]],
    }),

    watch: {
      coin: 'fetchValues',
    },

    mounted () {
      this.fetchValues();
    },

    methods: {
      async fetchValues () {
        const data = await createChartArray(this.coin.total, 30, 6 * 60 * 60 * 1000, 1000);
        const positive = data.slice(15, 30);
        const negative = data.slice(0, 16);

        this.positive = positive;
        this.negative = negative;
      },
    },

    computed: {
      ...mapState('coins', [
        'coins',
      ]),

      ...mapGetters('coins', [
        'coin',
      ]),

      prices () {
        return this.series[0].data.map(([, value]) => value);
      },

      series () {
        return [
          {
            data: this.positive,
          },
          {
            data: this.negative,
          },
        ];
      },

      options () {
        const colors = [
          '#60c100', '#ff001f',
        ];

        return {
          colors,

          chart: {
            toolbar: {
              show: false,
            },

            zoom: {
              enabled: false,
            },

            animations: {
              enabled: false,
            },
          },

          legend: {
            show: false,
            enabled: false,
          },

          dataLabels: {
            enabled: false,
          },

          markers: {
            size: 0,
            strokeWidth: 10,
            strokeOpacity: 0.2,
            hover: {
              size: 5,
            },
          },

          grid: {
            borderColor: 'rgba(255, 255, 255, 0.08)',
            padding: {
              top: 0,
              right: 5,
              left: 15,
              bottom: 26,
            },
          },

          stroke: {
            width: 2.5,
            curve: 'straight',
          },

          tooltip: {
            theme: false,

            custom: ({ series, seriesIndex, dataPointIndex, w }) => {
              const price = format(series[seriesIndex][dataPointIndex]);
              const day = new Date(this.series[0].data[dataPointIndex][0]);

              return `<div class="chart-crypto__label"><span class="chart-crypto__price">${price}</span> ${day.toLocaleString('pt-BR')}</div>`;
            },
          },

          fill: {
            colors,
            gradient: {
              opacityTo: 0,
              opacityFrom: .5,
            },
          },

          yaxis: {
            decimalsInFloat: 0,
            forceNiceScale: true,

            labels: {
              style: {
                cssClass: 'transaction-chart__label',
              },
            },
          },

          xaxis: {
            type: 'datetime',

            labels: {
              offsetY: 5,

              style: {
                cssClass: 'transaction-chart__label transaction-chart__label--x',
              },

              datetimeFormatter: {
                year: 'MM / yyyy',
                month: "MM / yyyy",
                day: 'dd / MM',
                hour: 'HH:mm',
              },
            },

            axisBorder: {
              color: 'rgba(255, 255, 255, 0.08)',
            },

            axisTicks: {
              height: 8,
              offsetY: 8,
              color: 'rgba(255, 255, 255, 0.3)',
            },

            tooltip: {
              enabled: false,
            },
          },
        };
      },
    },
  };
</script>

<style lang="scss">
  .transaction-chart {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    &__label {
      fill: #b2b8c5;
      font-size: 13px;
      font-family: Rubik;
      letter-spacing: 0.26px;
    }

    &__chart {
      padding: 0 24px 0 12px;
    }
  }
</style>
